import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = { class: "col-md-6 form-group" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = { class: "col-md-6 form-group" }
const _hoisted_10 = { class: "form-label fw-bold" }
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { class: "form-label fw-bold" }
const _hoisted_14 = { class: "d-flex justify-content-end" }
const _hoisted_15 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.filterOptions")), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("customDeclarationExport.status")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "status" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.status,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.status, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("customDeclarationExport.customsDeclarationNo")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "declaration_export_no",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.declaration_export_no,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.declaration_export_no) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("shipments.trackNumber")), 1),
              _createVNode(_component_el_form_item, {
                prop: "tracking_no",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.tracking_no,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-light btn-active-light-primary me-2",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
            }, _toDisplayString(_ctx.t("common.reset")), 1),
            _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.t("common.apply")), 1)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}